<template>
  <div class="mini-tab-content">
    <div
      v-if="loadingProblems"
      class="interc-loading"
    >
      <b-spinner
        small
        variant="danger"
      />
      <span>Carregando...</span>
    </div>
    <template v-else>
      <div class="interc-toolbar">
        <span class="interc-toolbar__title">
          <feather-icon
            icon="AlertCircleIcon"
            size="13"
            class="mr-25 text-danger"
          />
          {{ problemsCatalog.length ? problemsCatalog.length + ' problema(s)' : 'Nenhum problema' }}
        </span>
      </div>

      <div
        v-if="!problemsCatalog.length"
        class="interc-empty"
      >
        <feather-icon
          icon="AlertCircleIcon"
          size="26"
        />
        <p>Nenhum problema configurado para esta disciplina.</p>
      </div>

      <div
        v-else
        class="problem-list"
      >
        <div
          v-for="p in problemsCatalog"
          :key="p.id"
          class="problem-row"
        >
          <span class="problem-row__label">{{ p.label }}</span>
          <div
            class="problem-row__answers btn-group btn-group-sm"
            role="group"
          >
            <button
              type="button"
              class="btn"
              :class="problemAnswers[p.id] === true ? 'btn-success' : 'btn-outline-success'"
              :disabled="savingProblemId === p.id"
              @click="answerProblem(p, true)"
            >
              <b-spinner
                v-if="savingProblemId === p.id && pendingAnswer === true"
                small
              />
              <template v-else>
                Sim
              </template>
            </button>
            <button
              type="button"
              class="btn"
              :class="problemAnswers[p.id] === false ? 'btn-danger' : 'btn-outline-danger'"
              :disabled="savingProblemId === p.id"
              @click="answerProblem(p, false)"
            >
              <b-spinner
                v-if="savingProblemId === p.id && pendingAnswer === false"
                small
              />
              <template v-else>
                Não
              </template>
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import involvedPanelMixin from './involvedPanelMixin'

export default {
  name: 'ProblemsPanel',
  mixins: [involvedPanelMixin],
  data() {
    return {
      problemsCatalog: [],
      problemAnswers: {},
      loadingProblems: false,
      savingProblemId: null,
      pendingAnswer: null,
    }
  },
  mounted() {
    this.loadProblems()
  },
  methods: {
    async loadProblems() {
      this.loadingProblems = true
      try {
        const [catalogRes, answersRes] = await Promise.all([
          this.$http.get(`${this.$store.state.api}problems/for-occurrence/${this.occurrenceId}`),
          this.$http.get(`${this.$store.state.api}occurrence_involved_problems`, {
            params: {
              occurrence_id: Number(this.occurrenceId),
              involved_id: this.involvedId ? Number(this.involvedId) : undefined,
            },
          }),
        ])
        this.problemsCatalog = catalogRes.data.data || []
        const answers = answersRes.data.data || []
        const map = {}
        answers.forEach(a => {
          if (a.answer === true || a.answer === false) map[a.problem_id] = a.answer
        })
        this.problemAnswers = map
      } catch (e) {
        this.problemsCatalog = []
        this.$message('Erro', 'Não foi possível carregar os problemas.', 'error')
      } finally {
        this.loadingProblems = false
      }
    },
    async answerProblem(problem, answer) {
      const current = this.problemAnswers[problem.id]
      const newAnswer = current === answer ? null : answer
      this.savingProblemId = problem.id
      this.pendingAnswer = answer
      try {
        await this.$http.post(`${this.$store.state.api}occurrence_involved_problems`, {
          occurrence_id: Number(this.occurrenceId),
          involved_id: this.involvedId ? Number(this.involvedId) : null,
          problem_id: problem.id,
          answer: newAnswer,
        })
        this.$set(this.problemAnswers, problem.id, newAnswer)
      } catch (e) {
        this.$message('Erro', 'Erro ao salvar resposta.', 'error')
      } finally {
        this.savingProblemId = null
        this.pendingAnswer = null
      }
    },
  },
}
</script>
